import {useEffect, useState} from 'react';

import {VariantImage} from '../../api/models/variant-image';
import {VariantImageType} from '../../api/models/variant-image-type';
import {isServer} from '../_helper/isServer';

const useFilterAttachments = (type: VariantImageType, attachments?: VariantImage[]): VariantImage[] => {
    if (isServer()) return [];
    const [data, setData] = useState<VariantImage[]>([]);

    useEffect(() => {
        if (attachments) {
            setData(attachments.filter(attachment => attachment.type === type));
        }
        return () => {
            setData([]);
        }
    }, [attachments]);

    return data;
}

export default useFilterAttachments;